module.exports = __webpack_public_path__ + "img/ornament-842.ac637fe6.png";